import { useEffect, useState } from "react";
import {
  GreenThumb,
  LockSleepCoach,
  gameMilestone,
  TotalPoints,
  QuizCompleted,
  WeeklyRank,
} from "@utils/defaultImages.js";
import stepBack from "@assets/images/stepsBack.jpg";
import Rank3 from "@assets/images/Ranks3.svg";
import DashboardCharts from "@features/QuizGame/DashboardCharts.jsx";
import "swiper/css";
import "swiper/css/navigation";
import HeaderImage from "@assets/images/game.svg";
import BackImg from "@assets/images/stepsBack.jpg";
import MainHeader from "@components/ui/MainHeader.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import PastQuizes from "@features/QuizGame/PastQuizes.jsx";
// import TopPlayers from "@features/QuizGame/TopPlayers.jsx";
import { getQuizData } from "api/quizGame.js";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader.jsx";
import { placesSliderData, sliderData } from "data/uiData/RanksData.js";
import { useTranslation } from "react-i18next";
import { formatTimeStampDate } from "@utils/dateFormater.js";
import TopPlayers from "@features/QuizGame/TopPlayers";
// import Education from "./Education.jsx";
const QuizGameDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedDay, setSelectedDay] = useState(() => dayjs().format("dddd"));
  const [quizData, setQuizData] = useState(null);
  const [graphData, setGraphData] = useState(null);
  const [weeklyAdviseData, setWeeklyAdviceData] = useState(null);
  const [trackingData, setTrackingData] = useState(null);
  const [badgeLocked, setBadgeLocked] = useState(false);
  const [recentMilestone, setRecentMilestone] = useState(null);
  const { t } = useTranslation();
  //   useEffect(() => {
  //     if (!location?.state) {
  //       navigate(-1);
  //     }
  //   }, [location, navigate]);

  const nutrientData = [
    {
      label: t("quizGame.Total Points Earned"),
      key: "total_points_earned",
      icon: <TotalPoints className="w-[24px] h-[24px]" />,
      // unit: "g",
      tabColor: "#F0FFFF",
      value: quizData?.total_points_earned,
    },
    {
      label: t("quizGame.Quizzes Completed"),
      key: "quizzes_completed",
      icon: <QuizCompleted className="w-[24px] h-[24px]" />,
      // unit: "g",
      tabColor: "#FFF0FB",
      value: quizData?.quizzes_completed,
    },
    {
      label: t("quizGame.Weekly Rank"),
      key: "weekly_ranked",
      icon: <WeeklyRank className="w-[24px] h-[24px]" />,
      // unit: "g",
      tabColor: "#FFF6F0",
      value: quizData?.weekly_ranked ? `#${quizData.weekly_ranked}` : "N/A",
    },
    {
      label: t("quizGame.Last Played"),
      key: "lastPlayed",
      icon: <GreenThumb className="w-[24px] h-[24px]" />,
      // unit: "g",
      tabColor: "#F5FFF0",
      value: quizData?.last_played
        ? formatTimeStampDate(quizData?.last_played)
        : "N/A",
    },
  ];

  const fetchData = async () => {
    try {
      const response = await getQuizData();
      // console.log(response);
      setQuizData(response);
      setRecentMilestone(response?.recent_milestone_achieved);
      setGraphData(response?.weekly_graph_data);
    } catch (error) {
      console.log("failed to get quiz data :", error);
    } finally {
      setFirstLoad(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const displayMilestone = recentMilestone
    ? (() => {
        // try to match backend milestone with sliderData
        const matchedMilestone = (
          recentMilestone?.type === "milestone" ? sliderData : placesSliderData
        ).find((s) => s.title === recentMilestone?.last_achieved_milestone);
        return {
          title: recentMilestone.last_achieved_milestone,
          unlockDate: recentMilestone.unlockDate,
          isLocked: !recentMilestone.status,
          description: matchedMilestone?.description,
          type: recentMilestone?.type,
          RankImage: matchedMilestone?.RankImage,
        };
      })()
    : {
        ...sliderData[0],
        type: "milestone",
        isLocked: true,
      };

  // console.log(displayMilestone);

  if (!location?.state) {
    return (
      <div>
        {firstLoad ? (
          <ActualDietPlanLoader quizGame={true} />
        ) : (
          <>
            <MainHeader
              heading={t("quizGame.Your Personalized Wellness Quiz Game")}
              subheading={t(
                "quizGame.Engage, learn, and earn rewards—one question at a time."
              )}
              description={t(
                "quizGame.Answer goal-driven questions powered by ChatGPT. Get instant feedback, fun tips, and mini-games, then track your progress with points, badges, and virtual places—all tailored to reduce stress, improve nutrition, or boost fitness."
              )}
              Image={HeaderImage}
            />
            <div
              className="grid grid-cols-2 md:grid-cols-4 gap-3 my-9 px-4 py-5 rounded-[12px]"
              style={{ backgroundImage: `url(${BackImg})` }}
            >
              {nutrientData.map(({ label, icon, value, tabColor }, index) =>
                index === 3 ? (
                  <div
                    key={index}
                    className="pt-5 pb-1 px-2 rounded-[17px] bg-white border border-[#E6E6E6]  rounded-[16px]  gap-2"
                    style={{
                      boxShadow: "7px 7px 9.5px 0px #0000000D",
                    }}
                  >
                    <div className="px-3">
                      <p className="text-[12px]  font-[500] text-[#898787] font-[Lato] text-center md:text-start lg:text-center xl:text-start">
                        {label}
                      </p>
                      <div className="">
                        <p className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#6C6A6A] text-center lg:text-center xl:text-start">
                          {value}
                        </p>
                      </div>
                    </div>
                    <button
                      className="bg-[#64DDFF] py-[12px] w-full text-white rounded-full mt-2
            animate-pulse hover:animate-none"
                      onClick={() => navigate("/quiz-game/start-quiz")}
                    >
                      {t("quizGame.Start Quiz")}
                    </button>
                  </div>
                ) : (
                  <div
                    key={index}
                    className="py-8 px-2 rounded-[17px] bg-white border border-[#E6E6E6]  rounded-[16px] flex items-center flex-col xl:flex-row  justify-center gap-2 xl:gap-4"
                    style={{
                      boxShadow: "7px 7px 9.5px 0px #0000000D",
                    }}
                  >
                    <div className="flex justify-center">
                      <div
                        className="rounded-full min-w-[64px] min-h-[64px] max-w-[64px] max-h-[64px] flex items-center justify-center"
                        style={{
                          backgroundColor: tabColor,
                        }}
                      >
                        {icon}
                      </div>
                    </div>
                    <div>
                      <p className="text-[12px] md:text-[15px] font-[500] text-[#898787] font-[Lato] text-center md:text-start lg:text-center xl:text-start">
                        {label}
                      </p>
                      <div className="">
                        <p className="text-[16px] md:text-[22px] font-[500] font-[Lato] text-[#6C6A6A] text-center lg:text-center xl:text-start">
                          {value}
                        </p>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 mb-5">
              <div className="h-full">
                <TopPlayers topPlayers={quizData?.top_players_this_week} />
              </div>

              <div
                className="p-6 rounded-xl text-white bg-cover h-full flex flex-col relative"
                style={{ backgroundImage: `url(${stepBack})` }}
              >
                <div className="flex justify-between items-center mb-10">
                  <h4 className="text-[16px] font-[Lato] text-white">
                    {t("quizGame.Recent Milestone Achieved")}
                  </h4>
                  <button
                    className="bg-white rounded-md text-[#0575e6] text-[12px] font-[Lato] py-2 px-3"
                    onClick={() => navigate("/quiz-game/ranks")}
                  >
                    {t("View All")}
                  </button>
                </div>
                 <div className="flex-1 flex flex-col items-center ">
                  <div
                    className={` ${
                      !recentMilestone && "blur-[8px]"
                    } bg-white rounded-3xl w-[85%] p-5 relative pb-8 bg-white  flex flex-col items-center justify-center flex-1 `}
                  >
                    {" "}
                    {/* Added pb-8 for bottom padding */}
                    {displayMilestone?.type === "place" && (
                      <img
                        src={displayMilestone?.RankImage}
                        alt="image"
                        className={`w-full object-cover rounded-[12px] h-[120px]`}
                      />
                    )}
                    <div
                      className={`flex justify-center ${
                        displayMilestone?.type === "place"
                          ? "mt-2"
                          : " mt-[35%] sm:mt-[18%] lg:mt-[25%] xl:mt-[30%]"
                      }`}
                    >
                      <h3
                        className={`${
                          displayMilestone.isLocked
                            ? "text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] w-[fit-content] py-2 px-3 my-2"
                            : "text-[#000]"
                        }
                      text-[16px] font-[600] font-[Lato] text-center`}
                      >
                        {/* {t(
                          `quizGame.AllRanks.${displayMilestone?.title}.title`
                        )} */}
                        {displayMilestone?.type === "milestone"
                          ? t(
                              `quizGame.AllRanks.${displayMilestone?.title}.title`
                            )
                          : t(
                              `quizGame.AllPlaces.${displayMilestone?.title}.title`
                            )}
                      </h3>
                    </div>
                    <div className="flex justify-center">
                      {!displayMilestone.isLocked && (
                        <button
                          disabled
                          className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] py-2 px-4 text-[12px] my-2"
                        >
                          {(() => {
                            const date = new Date(displayMilestone?.unlockDate);
                            const day = date.getDate();
                            const monthName = date.toLocaleDateString("en-US", {
                              month: "long",
                            });
                            const translatedMonth = t(`month.${monthName}`);

                            return `${t(
                              "quizGame.Unlocked"
                            )} on ${day} ${translatedMonth}`;
                          })()}
                        </button>
                      )}
                    </div>
                    <div className="border border-[#DDDDDD] p-2 rounded-xl">
                      <p className="text-[12px] text-[#5C5C5C] text-center">
                        {displayMilestone?.type === "milestone"
                          ? t(
                              `quizGame.AllRanks.${displayMilestone?.title}.description`
                            )
                          : t(
                              `quizGame.AllPlaces.${displayMilestone?.title}.description`
                            )}
                      </p>
                    </div>
                    {displayMilestone?.type === "milestone" && (
                      <img
                        src={displayMilestone?.RankImage}
                        alt="image"
                        className={`absolute -top-[8%] 2xl:-top-[12%] left-1/2 -translate-x-1/2 z-[9] w-[40%] sm:w-[25%] md:w-[25%] lg:w-[30%] xl:w-[40%] object-cover" `} // Adjusted positioning and added width
                        style={{ maxHeight: "none" }}
                      />
                    )}
                  </div>
                </div>

                {displayMilestone?.isLocked && (
                  <img
                    src={LockSleepCoach}
                    alt="image"
                    className="absolute top-[40%] 2xl:top-[30%]  left-1/2 -translate-x-1/2 z-[9] object-cover w-[40px] sm:w-[50px]"
                  />
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5">
              {/* <div className=""> */}
              <DashboardCharts
                graphData={graphData}
                setGraphData={setGraphData}
              />
              {/* </div> */}
              <div>
                <PastQuizes quizHistory={quizData?.quiz_history} />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
};

export default QuizGameDashboard;
